import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import clsx from 'clsx';
import React from 'react';
import { BASIC_FILTERS_WRAPPER_ID } from './BasicFiltersWrapper.constant';

const useStyles = makeStyles(theme => ({
  filterSection: p => ({
    display: 'grid',
    gap: '1rem',
    width: '100%',
    marginTop: '0.5rem',
    marginBottom: '0.5rem',
    alignItems: 'center',
    gridTemplateColumns: `repeat(${p.numberOfFields}, 1fr)`,
    '& .advanced-autocomplete': {
      padding: '0',
    },
    '& .MuiAutocomplete-root': {
      margin: '0',
    },
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: `repeat(${Math.ceil(p.numberOfFields / 2)}, 1fr)`,
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
    },
  }),
  twoRows: p => ({
    [theme.breakpoints.down(1500)]: {
      gridTemplateColumns: `repeat(${Math.ceil(p.numberOfFields / 2)}, 1fr)`,
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
    },
  }),
  growFirstFilter: {
    '& > *:first-of-type': {
      minWidth: '190px',
      [theme.breakpoints.between('md', 'lg')]: {
        gridRow: 'span 2',
      },
    },
  },
}));

export const BasicFiltersWrapper = ({ children, numberOfFields, growFirstFilter, className }) => {
  const classes = useStyles({ numberOfFields });

  return (
    <Box
      className={clsx([classes.filterSection, className], {
        [classes.growFirstFilter]: growFirstFilter,
        [classes.twoRows]: numberOfFields > 6,
      })}
      id={BASIC_FILTERS_WRAPPER_ID}
    >
      {children}
    </Box>
  );
};
